import { deleteResponseVariables } from "actions/variables";
import { getResource } from "selectors/resources";
import { AsyncAction } from "actions/types";
import { Response } from "resourceModels";
import { setActiveLanguage } from "../actions";
import { getResponseEditorActiveLanguage } from "../selectors";

/** Delete variables created for a given language */
function deleteLanguageScopedVariables(responseId: string): AsyncAction {
  return (dispatch, getState) => {
    const activeLanguage = getResponseEditorActiveLanguage(getState(), responseId);

    return deleteResponseVariables(getState, dispatch, responseId, activeLanguage);
  };
}

export function handleDeleteLanguage(responseId: string, languageCode: string): AsyncAction {
  return (dispatch, getState) => {
    const state = getState();

    const client = getResource(state, "client");
    const response = getResource(state, "response", responseId);

    if (client.features.get("personalization")) {
      dispatch(deleteLanguageScopedVariables(response.id));
    }

    dispatch(setActiveLanguage(response.id, client.language));

    dispatch({
      type: "DELETE_LANGUAGE",
      responseId,
      languageCode
    });
  };
}

export function introsDeleteLanguage(
  response: Response,
  selectedLanguage: unknown,
  primaryLanguage: unknown,
  switchLanguage = false
): AsyncAction {
  return (dispatch, getState) => {
    const client = getResource(getState(), "client");

    if (client.features.get("personalization")) {
      dispatch(deleteLanguageScopedVariables(response.id));
    }

    dispatch({
      type: "DELETE_INTROS_LANGUAGE",
      response,
      selectedLanguage,
      primaryLanguage,
      switchLanguage
    });
  };
}
